export const MARKER_SIZE = 48;
export const MARKER_ICON_SIZE = MARKER_SIZE / 2;
